import { type TUserorbitApp, type OpenWidgetOptions } from "userorbit-js-core";
import { loadUserorbitToProxy } from "./lib/load-userorbit";

declare global {
  interface Window {
    userorbit: TUserorbitApp | undefined;
  }
}

function createProxyMethod<K extends keyof TUserorbitApp>(prop: K): TUserorbitApp[K] {
  return ((...args: Parameters<TUserorbitApp[K]>) => {
    return loadUserorbitToProxy(prop as string, ...args);
  }) as TUserorbitApp[K];
}

const userorbitProxyHandler: ProxyHandler<TUserorbitApp> = {
  get<T extends keyof TUserorbitApp>(_target: TUserorbitApp, prop: T, _receiver: TUserorbitApp): TUserorbitApp[T] {
    return createProxyMethod(prop);
  },
};

const userorbitApp: TUserorbitApp = new Proxy({} as TUserorbitApp, userorbitProxyHandler);

export type { OpenWidgetOptions };
export type { TUserorbitApp };

// eslint-disable-next-line import/no-default-export -- Required for UMD
export default userorbitApp;
